var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPencil({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "current",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.6878 3.62619L11.762 4.55197L9.44761 2.23467L10.3734 1.30889C10.562 1.12031 10.8905 1.12031 11.0791 1.30889L12.6878 2.92043C12.8821 3.11473 12.8821 3.43189 12.6878 3.62619ZM4.95308 11.3696L2.63867 9.05228L8.62185 3.06044L10.9363 5.37774L4.95308 11.3696ZM2.10436 10.1695L3.83588 11.9039L1.42432 12.584L2.10436 10.1695ZM13.5135 2.09466L11.9049 0.483118C11.5906 0.168811 10.4562 -0.425516 9.55047 0.483118L1.3986 8.64083C1.32717 8.71226 1.27574 8.79798 1.25002 8.89513L0.0213871 13.2697C-0.0357589 13.4726 0.0242444 13.6897 0.169967 13.8412C0.318546 13.9926 0.615705 14.0183 0.741426 13.9898L5.11309 12.7583C5.21024 12.7325 5.29596 12.6811 5.36739 12.6097L13.5135 4.45196C14.1622 3.80335 14.1622 2.74613 13.5135 2.09466Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencil);
export default __webpack_public_path__ + "static/media/pencil.47efdbaad4b6f45b6bab481cfc4ccbe7.svg";
export { ForwardRef as ReactComponent };